<template>
  <div class="page-add-third-party">
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li>
          <router-link :to="{ name: 'DashboardView' }">Dashboard</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'DashboardThirdParties' }"
            >Third Parties</router-link
          >
        </li>
        <li class="is-active">
          <router-link :to="{ name: 'AddThirdParty' }" aria-current="true"
            >Add</router-link
          >
        </li>
      </ul>
    </nav>

    <div class="columns is-multiline">
      <div class="column is-12">
        <h1 class="title">Add third party</h1>
      </div>

      <div class="column is-6">
        <div class="field">
          <label>Name</label>
          <div class="control">
            <input type="text" class="input" v-model="thirdParty.name" />
          </div>
        </div>

        <div class="field">
          <label>Email</label>
          <div class="control">
            <input type="email" class="input" v-model="thirdParty.email" />
          </div>
        </div>

        <div class="field">
          <label>Address 1</label>
          <div class="control">
            <input type="text" class="input" v-model="thirdParty.address1" />
          </div>
        </div>

        <div class="field">
          <label>Address 2</label>
          <div class="control">
            <input type="text" class="input" v-model="thirdParty.address2" />
          </div>
        </div>
      </div>

      <div class="column is-6">
        <div class="field">
          <label>Zipcode</label>
          <div class="control">
            <input type="text" class="input" v-model="thirdParty.zipcode" />
          </div>
        </div>

        <div class="field">
          <label>Place</label>
          <div class="control">
            <input type="text" class="input" v-model="thirdParty.place" />
          </div>
        </div>

        <div class="field">
          <label>Country</label>
          <div class="control">
            <input type="text" class="input" v-model="thirdParty.country" />
          </div>
        </div>
      </div>

      <div class="column is-12">
        <div class="field">
          <div class="control">
            <button class="button is-success" @click="submitForm">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/axios';

export default {
  name: 'AddThirdParty',
  data() {
    return {
      thirdParty: {},
    };
  },
  methods: {
    submitForm() {
      api
        .post('/third-parties/', this.thirdParty)
        .then(() => {
          this.$router.push({ name: 'DashboardThirdParties' });
        })
        .catch((error) => {
          console.log(JSON.stringify(error));
        });
    },
  },
};
</script>
